import React from 'react';
import {Control, UseFormGetValues, UseFormRegister, useWatch} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import Select from 'shared/ui/Select/Select';
import FormGroup from 'shared/ui/FormGroup/FormGroup';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import TextArea from 'shared/ui/TextArea/TextArea';
import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';

import SettingsArrow from '../SettingsArrow/SettingsArrow';

import styles from './CheckingContent.module.scss';

// eslint-disable-next-line max-len
export const getContentCheckHint = () => t`Можно указать до 5 строк и выбрать логику «и» или «или». Условие проверки: строки должны присутствовать или отсутствовать. Доступно для GET и POST.`;

interface ICheckingContentProps {
    item?: IHttpMonitorOutput,
    getValues: UseFormGetValues<any>,
    control: Control<any>,
    register: UseFormRegister<any>,
    enabled: boolean | undefined,
    onCheckboxClick?: () => void;
    disabled?: boolean;
    hideArrow?: boolean;
}

const CheckingContent: React.FC<ICheckingContentProps> = ({
    item,
    getValues,
    control,
    register,
    enabled,
    onCheckboxClick,
    disabled,
    hideArrow,
}) => {
    const isMonitorContentEnabled = useWatch({
        control,
        name: 'monitor_content_enabled',
        defaultValue: getValues('monitor_content_enabled'),
    });

    const handleCheckboxClick = () => {
        if (onCheckboxClick) {
            onCheckboxClick();
        }
    };

    return (
        <FormGroup className={styles.formGroup}>
            <div onClick={handleCheckboxClick}>
                <PremiumCheckbox
                    label={t`Мониторинг контента`}
                    helpText={getContentCheckHint()}
                    register={register('monitor_content_enabled')}
                    enabled={!!enabled}
                    disabled={disabled}
                />
            </div>
            {!hideArrow && (
                <SettingsArrow checkboxName="monitor_content_enabled" isOpen={isMonitorContentEnabled}/>
            )}
            {
                isMonitorContentEnabled &&
                (
                    <>
                        <TextArea
                            className={styles.textAria}
                            defaultValue={item?.monitor_content_data}
                            placeholder={t`Введите строки, которые нужно проверить`}
                            rows={5}
                            register={register}
                            name="monitor_content_data"
                            constraints={{required: true, minLength: 1}}
                        />
                        <div className={styles.blockSelects}>
                            <Select
                                rules={{required: true}}
                                defaultValue={item?.monitor_content_notify_logic}
                                placeholder={t`Логика уведомления`}
                                control={control}
                                name="monitor_content_notify_logic"
                                data={[
                                    {label: t`Уведомить, если найдены`, value: 'present'},
                                    {label: t`Уведомить, если не найдены`, value: 'not-present'},
                                ]}
                                searchable={false}
                                cleanable
                            />
                            <Select
                                rules={{required: true}}
                                defaultValue={item?.monitor_content_logic}
                                placeholder={t`И или ИЛИ`}
                                control={control}
                                name="monitor_content_logic"
                                data={[
                                    {label: t`Все строки (И)`, value: 'and'},
                                    {label: t`Часть строк (ИЛИ)`, value: 'or'},
                                ]}
                                searchable={false}
                                cleanable
                            />
                        </div>
                    </>
                )}
        </FormGroup>
    );
};

export default CheckingContent;